import { BaseTag } from 'mixs/base/base_mixin';

export class Table extends BaseTag {
  init(){
    super.init();
    this.watch();
  }

}
riot.mixin('table', Table as riot.TagMixin)
